<template >
    <div class="container-fluid" v-if="lesson">

        
      <div class="row">
        <div class="col-md-8 col-sm-12">
               <div class="card shadow mb-4" v-if="topic && item">
                <div class="card-header py-3">
                  <div class="row">

                      <div class="col">
                        <h4 class="m-0 font-weight-bold text-primary">{{topic.name}} / {{item.name}}</h4>
                        <p><span class="font-weight-bold">Товч нэр:</span> {{item.shortname}}</p>
                      </div>
                      <div class="col-auto" v-if="item.type">
                          <span class="badge badge-danger">{{getType(item.type)}}</span>
                      </div>

                  </div>
                </div>
                <div class="card-body" >

                    <div v-if="item">
                      <div class="d-flex w-100 justify-content-between">
                        
                      </div>
                      <p class="mb-1">{{item.description}}</p>
                      <p class="mb-1" v-if="item.duration">{{languages[lang].duration}} :{{item.duration}} минут</p>
                      <p class="mb-1" v-if="item.time"><span class="font-weight-bold">Шалгалтын үргэлжлэх хугацаа: </span>{{item.time}} минут</p>

                      <p class="mb-1" v-if="item.startDay!=null">{{languages[lang].start}} : {{item.startDay | formatDate}}</p>
                      <p class="mb-1" v-if="item.endDay!=null">{{languages[lang].end}}: {{item.endDay | formatDate}}</p>
                      <p v-if="item.totalScore && item.totalScore!='' && item.totalScore!=0">
                        {{languages[lang].maxscore}}: {{item.totalScore}}
                      </p>
                      <div v-if="item && contentScore && contentScore.earnedScore" class="text-primary text-lg font-weight-bold">
                        {{languages[lang].myscore}}: {{contentScore.earnedScore}}
                      </div>
                    <hr/>
                    <div v-if="item.type && (item.type=='exam' || item.type=='test') ">
                      <div v-if="item.block!=null">
                        <div class="alert alert-danger my-3 text-center" v-if="item.block!=undefined && item.block==true">
                          <h3>
                            Та энэ шалгалтанд орох эрхгүй байна.Хичээл зааж байгаа багш эсвэл сургалтын албандаа хандана уу.
                          </h3>
                        </div>
                        <div v-else>
                          <button class="btn btn-warning" @click="goStat(topic, item)">Шалгалтын үр дүн харах</button>

                          <!-- go to exam button -->
                          <button class="btn btn-danger ml-2" v-if="item.type!=null && (item.type=='exam') && item.exampublished==true" @click="goExamPage(topic, item)">Шалгалт өгөх</button>
                        </div>
                      </div>
                      <div v-else>...</div>
                      
                    </div>

                    <!-- <div class="iframe-container" style="overflow: hidden; padding-top: 56.25%; position: relative;">
                      <iframe style="border: 0; height: 100%; left: 0; position: absolute; top: 0; width: 100%;" frameborder="0" src="https://zoom.us/wc/74416818045/join?prefer=1&un=jGbS5" allow="microphone; camera; fullscreen"></iframe>
                    </div> -->

                    <div v-if="item.videoUrl">
                      <div :ref="'youtube_container_'+item.id"  class="video">
                        <youtube :resize="true" :fitParent="true" v-if="item.videoUrl" :video-id="getYoutubeIframe(item.videoUrl)" :ref="'youtube'+item.id" :player-vars="playerVars" @playing="playing(topic, item)"></youtube>
                        <br/>
                      
                        <!-- video control buttons -->
                        <button class="btn btn-primary" v-if="item.videoUrl!=null && item.videoUrl!=''"  @click="playVideo(item.id)"><i class="fas fa-play"></i> {{languages[lang].play}}</button>
                        <button class="btn btn-danger ml-3" v-if="item.videoUrl!=null && item.videoUrl!=''"  @click="pauseVideo(item.id)"><i class="fas fa-pause"></i> {{languages[lang].pause}}</button>
                        <button class="btn btn-info ml-3" v-if="item.videoUrl!=null && item.videoUrl!=''" @click="fullScreen(item.id)"><i class="fas fa-expand"></i> {{languages[lang].fullscreen}}</button>
                        <!-- <button class="btn btn-info ml-3" v-if="item.videoUrl!=null && item.videoUrl!=''" @click="exitfullScreen(item.id)"><i class="fas fa-expand"></i>Exit FullScreen</button> -->
                        <!-- <button class="btn btn-info ml-3" v-if="item.videoUrl!=null && item.videoUrl!=''" @click="exitfullScreen(item.id)"><i class="fas fa-compose"></i>Exit FullScreen</button> -->
                      </div>
                    </div>

                    <div class="my-3" v-if="item.iframeurl && item.iframeurl!='' && item && item.type && item.type!='exam' && item.type!='test'">
                      <div id="iframecontainer" v-html="item.iframeurl">
                      </div>
                    </div>
                      <div v-if="item.fileUrls!=null && item.fileUrls.length>0">
                        <hr/>
                        <h5 class="text-center">{{languages[lang].files}}</h5>
                        <table class="table table-bordered table-sm" >
                        
                          <tr v-for="(file, index) in item.fileUrls" >
                            <td>{{file.name}}</td>
                            <td>{{file.description}}</td>
                            <td>
                              <a class="btn btn-outline-primary btn-sm mr-2" v-bind:href="file.link" target="_blank">
                                <i class="fas fa-download"></i> 
                                {{languages[lang].download}}
                              </a>
                            </td>
                          </tr>
                        </table>
                      </div>


                    </div>

                </div>

                <section class="content-item" id="comments">
                  <div class="container">         
                    <div class="row">
                      <div class="col">   
                          <form>
                            <h3 class="pull-left">{{languages[lang].comment}}</h3>
                            
                              <fieldset>
                                <div class="row">
                                  
                                  <div class="form-group col-xs-12 col-sm-9 col-lg-10">
                                    <textarea v-model="commentText" rows="2" class="form-control" id="message" placeholder="Таны сэтгэгдэл" required=""></textarea>
                                  </div>
                                  <div class="col col-auto">
                                    <button @click="saveComment" type="button" class="btn btn-success pull-right">{{languages[lang].send}}</button>
                                  </div>
                                </div>  	
                              </fieldset>
                          </form>
                          
                          <h3 v-if="item.numberOfComments">{{item.numberOfComments}} {{languages[lang].comment}}</h3>

                          <div class="media" v-for="comment in item.comments">
                              <!-- <a class="pull-left" href="#"><img class="media-object" src="https://bootdey.com/img/Content/avatar/avatar1.png" alt=""></a> -->
                              <div class="media-body">
                                  <h4 class="media-heading" v-if="comment.customerData">{{comment.customerData.name}} - {{comment.customerData.code}}</h4>
                                  <p >{{comment.text}}</p>
                                  <ul v-if="comment.createdAt" class="list-unstyled list-inline media-detail pull-left">
                                      <li><i class="fa fa-calendar"></i>{{comment.createdAt | formatDate}}</li>
                                  </ul>
                                
                              </div>
                          </div>
                          
                      
                      </div>
                      </div>
                  </div>
              </section>

            </div>
        </div>
        <div class="col-md-4 col-sm-12">
              <div class="card pl-3">
                <h4 class="p-3 text-center">{{languages[lang].lessoncontent}}</h4>
                <div v-for="(topic) in topics" v-if="topics!=null && topics.length>0 && topic && topic.details && topic.details.length>0">
                    <h4 class="my-2 card-title text-primary mb-0">{{topic.name}}</h4>
                    <hr class="mt-0"/>
                    <div class="row mb-2" v-for="(item, index) in topic.details" @click="setCurrentVideo(topic, item)">
                        <div class="col-md-4">
                          <div v-if="item.videoUrl">
                              <a style="cursor:pointer">
                                  <img style="width: 100%;" :src="getYoutubeImg(item.videoUrl)" alt="">
                              </a>
                          </div>
                          <div v-else class="my-2">
                             <a style="cursor:pointer">
                                  <img style="width: 100%;" :src="'https://via.placeholder.com/300x200/09f/fff.png?text='+item.name" alt="">
                              </a>
                          </div>
                        </div>
                        <div class="col-md-8">
                            <div><span class="text-primary" style="cursor:pointer">{{item.name}}</span></div>
                            <div class="badge badge-warning" style="color:black">{{getType(item.type)}}</div>
                            <!-- <p class="views">xxx</p> -->
                        </div>
                    </div>
                </div>
  
              </div>
          </div>
      </div>

    </div>
    
</template>

<script>
const fb = require('../../firebaseConfig.js')
import { mapState } from 'vuex'
import moment from 'moment'
import firebase from 'firebase'
import LessonHeader from '../shared/ILessonHeader';
import PublicTopics from './PublicTopics';
import Vue from 'vue';
import VueYoutube from 'vue-youtube';
import lang from '../lang.js';

Vue.use(VueYoutube);

export default {
    name: "StudentContentDetail",
    components:{
      LessonHeader,
      PublicTopics
    },
    mixins:[lang],
    data() {
        return {
            lesson: null,
            topic:null,
            item:null,
            types:[],
            selectedType:null,
            content:{

            },
            itemDetails:[],
            selectedTopic:null,

            display:0,
            sub:{
              "name":null
            },
            playerVars: {
              autoplay: 0,
              modestbranding: 1,
              showinfo:0,
              rel:0,
              fs:0,
              allowfullscreen:1
              // controls:0,
              // allowfullscreen:true,
              // autohide:1
            },
            semesters:[],
            topics:[],
            school:null,
            commentText:null,
            enabled:false,
            contentScore:null
            
        };
    },

    methods: {
      setCurrentVideo(topic, item){
        this.$nextTick(() => {
          window.scrollTo({ top: 0, behavior: 'smooth' });
          this.playerVars={
              autoplay: 0,
              modestbranding: 1,
              showinfo:0,
              rel:0,
              fs:0,
              allowfullscreen:1
              // controls:0,
              // allowfullscreen:true,
              // autohide:1
            };
          this.topic=topic;
          item.block=null;
          this.item = item;
          this.setContentScore();
          this.checkAccessExam();
        });
       
      },
      setContentScore(){
        this.contentScore=null;
        if(this.topic && this.item && this.item.type && this.item.type=='assignment' && this.item.showScore!=null && this.item.showScore!=undefined && this.item.showScore==true && this.userProfile && this.userProfile.customer ){
          
          var contentRef=fb.db.collection("lessons").doc(this.lessonId).collection("topics").doc(this.topic.id).collection("details").doc(this.item.id);
          contentRef.collection("sstudents").doc(this.userProfile.customer.id).get().then(doc=>{
            if(doc && doc.exists){
              this.contentScore=doc.data();
            }
          });
        }
      },
      async checkAccessExam(){
        if(this.topic && this.item && this.item.type && (this.item.type=='test' || this.item.type=='exam') && this.userProfile && this.userProfile.customer){
          var contentRef=fb.db.collection("lessons").doc(this.lessonId).collection("topics").doc(this.topic.id).collection("details").doc(this.item.id);
          contentRef.collection("users").doc(this.currentUser.uid).get().then(doc=>{
            if(doc.exists && doc.data().block && doc.data().block==true){
              this.item.block=true;
            }
            else{
              this.item.block=false;
            }
          });
        }
      },
      async playVideo(videoId){
        if(this.$refs['youtube'+videoId].player){

          await this.$refs['youtube'+videoId].player.playVideo();
        }
      },
      async pauseVideo(videoId){

        if(this.$refs['youtube'+videoId].player!=undefined)
          await this.$refs['youtube'+videoId].player.pauseVideo();
      },
      fullScreen(videoId){
        Vue.nextTick(()=>{
          if(this.$refs['youtube'+videoId].player!=undefined){
            var player=this.$refs['youtube'+videoId].player;
            player.playVideo();//won't work on mobile

              var iframe=this.$refs['youtube_container_'+videoId];
              var requestFullScreen = iframe.requestFullScreen || iframe.mozRequestFullScreen || iframe.webkitRequestFullScreen || iframe.msRequestFullscreen;
              if (requestFullScreen) {
                requestFullScreen.bind(iframe)();
              }
          }
        });
        
      },
      exitfullScreen(videoId){
        if(this.$refs['youtube'+videoId].player!=undefined){
          var player=this.$refs['youtube'+videoId].player;
          player.playVideo();//won't work on mobile
     
            var document=this.$refs['youtube_container_'+videoId];
             if (document.exitFullscreen) {
                  document.exitFullscreen();
              } else if (document.webkitExitFullscreen) {
                  document.webkitExitFullscreen();
              } else if (document.mozCancelFullScreen) {
                  document.mozCancelFullScreen();
              } else if (document.msExitFullscreen) {
                  document.msExitFullscreen();
              }

        }
      },
      playing(topic, content) {
        fb.db.collection("lessons").doc(this.lessonId).collection("studentList").doc(this.$store.getters.userProfile.customer.id).get().then(std=>{
            if(std.exists){
              if(this.$store.getters.userProfile!=null && this.$store.getters.userProfile.role=="student"){
                if(topic!=null && content!=null){
                  var contentRef=fb.db.collection("lessons").doc(this.lessonId).collection("topics").doc(topic.id).collection("details").doc(content.id);
                  contentRef.collection('watchedStudents').doc(std.id).get().then(stdWatch=>{
                    if(stdWatch.exists){
                      stdWatch.ref.update({watchedDates: fb.firestore.FieldValue.arrayUnion(new Date())});
                    }
                    else{
                      stdWatch.ref.set({"createdAt":new Date(), watchedDates:[new Date()]});
                      this.countStudentVideo(topic, content, 'viewCount');
                    }
                  });
                }
              }
            }

          });
      },
      countStudentVideo(topic, content, prop){
        if(this.$store.getters.userProfile!=null && this.$store.getters.userProfile.role=="student"){
          if(topic!=null && content!=null){
            var contentRef=fb.db.collection("lessons").doc(this.lessonId).collection("topics").doc(topic.id).collection("details").doc(content.id);
            var updateObj={};
            updateObj[prop]=fb.firestore.FieldValue.increment(1);
            contentRef.update(updateObj);
          }
        }
      },
      _getQA(){

        fb.db
          .doc( "lessons/" + this.lessonId)
          .collection("topics")
          .orderBy("createdAt", "desc")
          .get().then((querySnapshot) => {
            this.topics = [];
            querySnapshot.forEach((doc) => {
              let object = doc.data();
              object.id = doc.id;
              object.details = [];
              if (!object.published) object.published = null;
              doc.ref
                .collection("details")
                .orderBy("createdAt")
                .get().then((contentSnapshot) => {
                  object.details = [];
                  contentSnapshot.forEach((contentDoc) => {
                    let content = contentDoc.data();
                    content.id = contentDoc.id;
                    content.uploading = false;
                    content.uploadPercent = 0;
                    content.block=null;
                    content.comments=[];

                    contentDoc.ref.collection("content_comments").orderBy("createdAt", "desc").onSnapshot(cquerysnapshot=>{
                      content.comments=[];
                      if(cquerysnapshot && !cquerysnapshot.empty){
                        cquerysnapshot.docs.forEach(cdoc=>{
                          if(cdoc.exists){
                            let comment=cdoc.data();
                            comment.id=cdoc.id;
                            comment.customerData=null;
                            if(comment.customer){
                              comment.customer.get().then(studentData=>{
                                comment.customerData=studentData.data();
                              });
                            }
                            content.comments.push(comment);
                          }
                        });
                      }
                    });
                    if(content && content.iframeurl){
                      if(content.iframeurl.includes("docs.google.com/document")){
                        content.iframeurl=content.iframeurl.replace("<iframe ", "<iframe style='heigth:1024px'");
                      }
                    }
                    object.details.push(content);
                  });
                });
              this.topics.push(object);
            });
          });


        fb.db.collection("lessons").doc(this.lessonId).get().then(async doc => {
            let lesson=doc.data();
            lesson.id=doc.id;
            this.lesson=lesson;

            if(this.lesson && this.lesson.semester){
              var paymentDoc=await fb.db.collection("students").doc(this.$store.getters.userProfile.customer.id).collection("paymentHistory").doc(this.lesson.semester.id).get();
              if(paymentDoc.exists && paymentDoc.data() && paymentDoc.data().paid==true){
                this.enabled=true;
              }
              else{
                this.enabled=false;
              }

            }
            doc.ref.collection("topics").doc(this.topicId).get().then(tdoc=>{
              if(tdoc.exists){
                let topic=tdoc.data();
                topic.id=tdoc.id;
                this.topic=topic;

                tdoc.ref.collection("details").doc(this.contentId).get().then(cdoc=>{
                  if(cdoc.exists){
                    let item=cdoc.data();
                    item.id=cdoc.id;
                    item.uploading=false;
                    item.uploadPercent=0;
                    item.comments=[];
                    item.block=null;
                    if(item && item.iframeurl){
                      if(item.iframeurl.includes("docs.google.com/document")){
                        item.iframeurl=item.iframeurl.replace("<iframe ", "<iframe style='height:1024px!important;'");
                      }
                    }
                    this.item=item;
                    this.setContentScore();
                    cdoc.ref.collection("subdetails").orderBy("createdAt", "desc").onSnapshot(docs=>{
                      if(docs!=null && !docs.empty){
                        this.itemDetails=docs.docs;
                      }
                    });
                    cdoc.ref.collection("content_comments").orderBy("createdAt", "desc").onSnapshot(cquerysnapshot=>{
                      item.comments=[];
                      if(cquerysnapshot && !cquerysnapshot.empty){
                        cquerysnapshot.docs.forEach(commentdoc=>{
                          if(commentdoc.exists){
                            let comment=commentdoc.data();
                            comment.id=commentdoc.id;
                            comment.customerData=null;
                            if(comment.customer){
                              comment.customer.get().then(studentData=>{
                                comment.customerData=studentData.data();
                              });
                            }
                            item.comments.push(comment);
                          }
                        });
                      }
                    });
                    this.checkAccessExam();
                  }
                });
              }
            });
          
        });


      },

      goStat(type, topic){
        this.$router.push({ name: 'TopicStat', params: { lessonId: this.lessonId, type: type.id, topicId: topic.id} })
      },


      setPropContent(value,topic, item, propertyName){
        if(this.lesson!=null && topic!=null && item!=null && propertyName!=null)
          this.setProperty(propertyName, fb.db.doc("lessons/"+this.lesson.id+"/topics/"+topic.id+"/details/"+item.id), value);
      },
      setProperty(propertyName, object, value){
        if(object!=null && propertyName!=null){
          var tmp={};
          tmp[propertyName]=value;
          object.update(tmp);
        }
      }
      ,
      validFile(file){
        if(file.fileName.endsWith("mp4") 
            || file.fileName.endsWith("MP4") 
            || file.fileName.endsWith("MPEG") 
            || file.fileName.endsWith("mov") || file.fileName.endsWith("MOV")
            || file.fileName.endsWith("webm") || file.fileName.endsWith("WEBM")
          ){
            return false;
        }
        return true;
      },
      getYoutubeId(url) {
          const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
          const match = url.match(regExp);

          return (match && match[2].length === 11)
            ? match[2]
            : null;
      },
      getYoutubeImg(url){
        if(url){
          var id=this.getYoutubeId(url);
          if(id){
            return "https://img.youtube.com/vi/"+id+"/1.jpg";
          }
        }
        return null;
      },
      getYoutubeIframe(url){
        if(url!=null && url!='' && url.toLowerCase().indexOf("youtube") != -1){
          var id= this.getYoutubeId(url);
          return id ;
        }
        return null;
      },
      getType(type){
        if(!this.lang || this.lang=='mn'){
          if(type=="test")
            return "Тест давтлага";
          else if(type=="video")
            return "Хичээл";
          else if(type=="lecture")
            return "Хичээл";
          else if(type=="seminar")
            return "Семинар";
          else if(type=="exam")
            return "Шалгалт";
          else if(type=="homework")
            return "Гэрийн даалгавар";
          else if(type=="coursework")
            return "Бие даалт";
          else if(type=="assignment")
            return "Даалгавар";
        }
        else if(this.lang=='english')
          return type;
        
      },
      async saveComment(){
        if(this.commentText && this.commentText!='' && this.commentText.length>=2 && this.userProfile && this.userProfile.customer){
          var contentRef=fb.db.collection("lessons").doc(this.lessonId).collection("topics").doc(this.topic.id).collection("details").doc(this.item.id);
          await contentRef.collection("content_comments").doc().set(
            {
              createdAt:new Date(),
              customer:this.userProfile.customer,
              user: fb.db.collection("users").doc(this.currentUser.uid),
              text:this.commentText,
              content: contentRef,
              topic: fb.db.collection("lessons").doc(this.lessonId).collection("topics").doc(this.topic.id),
              lesson:fb.db.collection("lessons").doc(this.lessonId),
            

            }
          );
          contentRef.update({numberOfComments:fb.firestore.FieldValue.increment(1)});
          this.commentText=null;
        }
      },
      goStat(topic, item){
        if(topic!=null && item!=null && item.type!=null && item.type!=undefined && (item.type=='exam' || item.type=='test')){
          this.$router.push({ name: 'TestResult', params: { lessonId: this.lessonId, topicId: topic.id, contentId: item.id} });
        }
      },
      goExamPage(topic, item){
        if(topic!=null && item!=null && item.type!=null && item.type!=undefined && (item.type=='exam' || item.type=='test')){
          this.$router.push({ name: 'ExamPage', params: { lessonId: this.lessonId, topicId: topic.id, contentId: item.id} });
        }
      }
    },
    computed: {
        ...mapState(['userProfile', 'currentUser', 'lang'])
    },
    props: {
      lessonId: { 
          required: true,
      },
      topicId:{
        required:true
      },
      contentId:{
        required:true
      } ,
      showContainer:{
        required:false
      }
    },
    created() {
        var _this=this;
        if(this.lessonId!=null && this.lessonId!='')
          this._getQA();
            
    },
    filters: {
		  formatDate(val) {
          if (!val) { return '-' }
          let date = val.toDate()
          return moment(date).format('MM/DD/YYYY HH:mm');
      },
    }
  
};
</script>
<style>
    .video iframe {
        pointer-events: none;
        
    }
    #iframecontainer iframe{
      width:100%!important;
    }

.content-item {
    padding:30px 0;
}

.content-item.grey {
	background-color:#F0F0F0;
	padding:30px 0;
	height:100%;
}

.content-item h2 {
	font-weight:700;
	font-size:35px;
	line-height:45px;
	text-transform:uppercase;
	margin:20px 0;
}

.content-item h3 {
	font-weight:400;
	font-size:20px;
	color:#555555;
	margin:10px 0 15px;
	padding:0;
}

.content-headline {
	height:1px;
	text-align:center;
	margin:20px 0 70px;
}

.content-headline h2 {
	background-color:#FFFFFF;
	display:inline-block;
	margin:-20px auto 0;
	padding:0 20px;
}

.grey .content-headline h2 {
	background-color:#F0F0F0;
}

.content-headline h3 {
	font-size:14px;
	color:#AAAAAA;
	display:block;
}


#comments {
	background-color:#FFFFFF;
}

#comments form {
	margin-bottom:30px;
}

#comments .btn {
	margin-top:7px;
}

#comments form fieldset {
	clear:both;
}

#comments form textarea {
	height:100px;
}

#comments .media {
	border-top:1px dashed #DDDDDD;
	padding:20px 0;
	margin:0;
}

#comments .media > .pull-left {
    margin-right:20px;
}

#comments .media img {
	max-width:100px;
}

#comments .media h4 {
	margin:0 0 10px;
}

#comments .media h4 span {
	font-size:14px;
	float:right;
	color:#999999;
}

#comments .media p {
	margin-bottom:15px;
	text-align:justify;
}

#comments .media-detail {
	margin:0;
}

#comments .media-detail li {
	color:#AAAAAA;
	font-size:12px;
	padding-right: 10px;
	font-weight:600;
}

#comments .media-detail a:hover {
	text-decoration:underline;
}

#comments .media-detail li:last-child {
	padding-right:0;
}

#comments .media-detail li i {
	color:#666666;
	font-size:15px;
	margin-right:10px;
}
</style>
